'use strict';

export default class ResetPasswordController {
  /*@ngInject*/
  constructor($http, $stateParams, $state, $timeout, $scope, baseConfigService) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$timeout = $timeout;
    this.baseConfigService = baseConfigService;

    this.token = $stateParams.token;
    this.verified = false;
    this.verifying = true;
    this.error = '';
    this.resetError = '';
    this.resendError = '';
    this.password = '';
    this.confirmPassword = '';
    this.resendEmail = '';
    this.resendSubmitted = false;
    this.resendSending = false;
    this.resendSent = false;
    this.resendSuccessMessage = '';
    this.redirectPromise = null;
    this.submitted = false;
    this.resetting = false;
    this.passwordMismatch = false;

    $scope.$on('$destroy', () => {
      if (this.redirectPromise) {
        this.$timeout.cancel(this.redirectPromise);
      }
    });

    this.verifyToken();
  }

  verifyToken() {
    if (!this.token) {
      this.verifying = false;
      this.error = 'No reset token provided. Please request a new password reset link.';
      return;
    }

    const adminBaseURL = this.baseConfigService.getAdminBaseURL();
    this.$http.post(`${adminBaseURL}/email/verifyResetToken`, { token: this.token }, {
      skipAuthRedirect: true
    })
      .then((res) => {
        if (res.data.valid) {
          this.email = res.data.email;
          this.resendEmail = res.data.email;
        } else {
          this.error = 'This reset link is invalid or has expired. Please request a new one.';
        }
        this.verified = true;
        this.verifying = false;
      })
      .catch(() => {
        this.verifying = false;
        this.error = 'This reset link is invalid or has expired. Please request a new one.';
      });
  }

  resendResetLink(form) {
    if (this.resendSending) {
      return;
    }

    this.resendSubmitted = true;
    this.resendError = '';
    this.resendSuccessMessage = '';

    if (!form.$valid) {
      return;
    }

    this.resendSending = true;

    const adminBaseURL = this.baseConfigService.getAdminBaseURL();
    const resetCallbackUrl = `${window.location.origin}/reset-password`;

    this.$http.post(`${adminBaseURL}/email/sendReset`, {
      to_email: this.resendEmail,
      reply_to_email: 'trodriguez@bayareametro.gov',
      subject: 'Reset Your Password',
      reset_callback_url: resetCallbackUrl
    }, {
      skipAuthRedirect: true
    })
      .then(() => {
        this.resendSending = false;
        this.resendSent = true;
        this.resendSuccessMessage = 'If an account exists for that email, a password reset link has been sent.';
        this.scheduleHomeRedirect();
      })
      .catch(() => {
        this.resendSending = false;
        this.resendSent = true;
        this.resendSuccessMessage = 'If an account exists for that email, a password reset link has been sent.';
        this.scheduleHomeRedirect();
      });
  }

  scheduleHomeRedirect() {
    if (this.redirectPromise) {
      this.$timeout.cancel(this.redirectPromise);
    }

    this.redirectPromise = this.$timeout(() => {
      this.$state.go('main');
    }, 7000);
  }

  submit(form) {
    this.submitted = true;
    this.resetError = '';
    this.passwordMismatch = false;

    if (!form.$valid || this.password !== this.confirmPassword) {
      if (this.password !== this.confirmPassword) {
        this.passwordMismatch = true;
      }
      return;
    }

    this.resetting = true;

    const adminBaseURL = this.baseConfigService.getAdminBaseURL();
    this.$http.post(`${adminBaseURL}/users/update-pwd-tp`, {
      token: this.token,
      newPassword: this.password
    }, {
      skipAuthRedirect: true
    })
      .then(() => {
        this.resetting = false;
        const $modal = $('#resetSuccessModal');

        this.registerSuccessModalCleanup($modal, true);

        // Show Bootstrap modal
        $modal.modal('show');
      })
      .catch(err => {
        this.resetting = false;
        this.resetError = 'Failed to reset password. Please try again or request a new link.';
      });
  }

  registerSuccessModalCleanup($modal, goToLogin) {
    $modal.off('hidden.bs.modal').one('hidden.bs.modal', () => {
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open').css('padding-right', '');

      if (goToLogin) {
        this.goToLogin();
      }
    });
  }

  closeSuccessModal() {
    const $modal = $('#resetSuccessModal');
    this.registerSuccessModalCleanup($modal, true);
    $modal.modal('hide');
  }

  goToLogin() {
    this.$state.go('login');
  }
}



// WEBPACK FOOTER //
// ./client/app/account/reset-password/reset-password.controller.js